import {css} from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    background-color: white;
    flex-direction: column;
    overflow-x: hidden;
`;

export const widthCss = css`
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    /*padding: 120px 30px;*/
    width:100%;
    margin: 0 auto;
    justify-content: center;
    gap: 90px;

    
    .profile {
       display: flex;
        flex-direction: row;
        gap: 24px;
    }
    
`;
